import { Image, MediaContentDTO } from './Image'
import { Project, ProjectDTO } from './Project'
import { AgreementItem, AgreementItemDTO } from './AgreementItem'
import { AgreementScope, AgreementScopeDTO } from './AgreementScope'
import { EntityStatusTypes } from './EntityStatusTypes'
import { User } from '../utilities'

export interface AgreementDTO {
  budget: number
  budgetBuffer: number
  budgetRemaining: number
  budgetSpent: number
  createdDate: number
  effectOnElements: boolean
  endDate: number
  externalId: string
  id: number
  images: MediaContentDTO[]
  info: string
  items: AgreementItemDTO[]
  loadContents: boolean
  mainImage: MediaContentDTO
  name: string
  organizationId: number
  ownerId: string
  relatedMedia: ProjectDTO[]
  scopes: AgreementScopeDTO[]
  startDate: number
  status: EntityStatusTypes
  agreementStatus: AgreementStatusTypes
  tags: string
  previous?: AgreementDTO
  updatedBy?: string
}

export enum AgreementStatusTypes {
  ACTIVE = 'ACTIVE',
  NOT_ACTIVE = 'NOT ACTIVE',
  DRAFT_STORE = 'DRAFT STORE',
  DRAFT_PROJECT = 'DRAFT PROJECT',
  PENDING_STORE_APPROVAL = 'PENDING STORE APPROVAL',
  PENDING_PROJECT_APPROVAL = 'PENDING PROJECT APPROVAL',
  AGREED = 'AGREED',
  NEW = 'NEW',
  EXPIRED = 'EXPIRED'
  // NO BUDGET
  // EXPIRED
  // CANCELED
}

export class Agreement {
  id: number
  name: string
  info: string
  status: AgreementStatusTypes
  agreementStatus: AgreementStatusTypes
  createdDate: Date
  images: typeof Image[]
  mainImage: Image
  relatedMedia: Project[]
  loadContents: boolean
  externalId: string
  ownerId: string
  startDate: Date
  endDate: Date
  period: any
  effectOnElements: boolean
  budget: number
  budgetSpent: number
  budgetBuffer: number
  budgetRemaining: number
  organizationId: number
  items: AgreementItem[]
  scopes: AgreementScope[]

  constructor (agreement: Agreement) {
    for (const property in agreement) {
      this[property] = agreement[property]
    }
  }
}

export const getAgreementStatusLabel = (status: AgreementStatusTypes): string => {
  switch (status) {
    case AgreementStatusTypes.DRAFT_PROJECT:
    case AgreementStatusTypes.DRAFT_STORE:
      return 'Draft'
    case AgreementStatusTypes.PENDING_PROJECT_APPROVAL:
      return User.isShopOwner() ? 'Sent for approval' : 'Pending approval'
    case AgreementStatusTypes.PENDING_STORE_APPROVAL:
      return User.isShopOwner() ? 'Pending approval' : 'Sent for approval'
    case AgreementStatusTypes.AGREED:
      return 'Active'
      case AgreementStatusTypes.EXPIRED:
        return 'Not active'

    default:
      return status.toLowerCase()
  }
}
